import React, { useState } from 'react';
import logo from '../../../styles/medias/images/logo.svg';
import iso from '../../../styles/medias/images/iso9001.png';
import { Link } from 'gatsby';
import useFetch from '../../hooks/useFetch';

const Footer = () => {
	const [reload] = useState({ endPoint: null, isClicked: 0 });
	const productResponse = useFetch(`produits/`, [{}], reload);
	return (
		<footer>
			<div className="iso-div">
				<img src={iso} />
			</div>
			<div className="container">
				<div className="footer-top">
					<div className="newsletter">
						<div className="logo">
							<img src={logo} />
						</div>
					</div>
					<div className="suiveznous">
						<h3>Suivez nous sur:</h3>
						<div className="social">
							<ul>
								<li>
									<a className="instagram" href="#">
										Instagram
									</a>
								</li>
								<li>
									<a className="twitter" href="#">
										Twitter
									</a>
								</li>
								<li>
									<a className="facebook" href="#">
										Facebook
									</a>
								</li>
								<li>
									<a className="linkden" href="#">
										Linkden
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div className="footer-bottom">
					<div className="bloc col-md-3">
						<h3>Maroc leasing</h3>
						<ul>
							<li>
								<Link to="/apropos">A propos</Link>
							</li>
							<li>
								<Link to="/equipe">Comité de direction</Link>
							</li>
							<li>
								<Link to="/reseau">Notre réseau</Link>
							</li>
						</ul>
					</div>
					<div className="bloc col-md-3">
						<h3>Nos Produits</h3>
						<ul>
							{productResponse.complete &&
								productResponse.data &&
								productResponse.data.map((product, idx) => {
									return (
										<li key={idx}>
											<Link to={`/products/?pid=${product.id}`}>{product.titre}</Link>
										</li>
									);
								})}
						</ul>
					</div>
					<div className="bloc col-md-3">
						<h3>Média</h3>
						<ul>
							<li>
								<Link to="/publication">Communication financière</Link>
							</li>
							<li>
								<Link to="/presse">Presse</Link>
							</li>
						</ul>
					</div>
					<div className="bloc col-md-3">
						<h3>Contact</h3>
						<ul>
							<li>
								<Link to="/contact">Demande d'information</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</footer>
	);
};
export default Footer;
